module.exports = __webpack_public_path__ + "static/img/img-kjxzxqy-good-05.24f39fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img-kjxzxqy-good-05.jpg
// module id = Bi6l
// module chunks = 1